<template>
  <header :class="[{ [$style.isFixed]: isFixed }, $style.header]">
    <!-- <div class="header__Inner"> -->
    <!-- <div class="container--big"> -->
    <div class="header__headerList d-flex justify-content-between align-items-center">
      <div class="header__left">
        <router-link :to="{ name: 'home' }">
          <img v-if="isFixed === true || $route.name === 'home'" alt="logo" class="header__logo d-lg-block d-none" src="@assets/images/home/logo-menu.svg" />
          <img v-else alt="logo" class="header__logo d-lg-block d-none" src="@assets/images/home/logo-menuWhite.svg" />
          <img alt="logo" class="header__logo d-lg-none d-block" src="@assets/images/home/logo-menu.svg" />
        </router-link>
      </div>
      <div class="header__right">
        <div class="burger d-lg-none d-block" @click="isMenuOpen = !isMenuOpen" @keydown="isMenuOpen = !isMenuOpen">
          <div v-if="isMenuOpen">
            <i class="icomoon icon-menu-close"></i>
          </div>
          <div v-else>
            <i class="icomoon icon-menu"></i>
          </div>
        </div>
        <div :class="{ isActive: isMenuOpen }" class="header__menuList justify-content-lg-end">
          <div v-for="(item, $index) in menuList" :key="$index" class="header__menuItem">
            <router-link :to="{ name: item.alias }" class="header__link">
              {{ item.title }}
            </router-link>
          </div>
          <div class="header__menuItem">
            <BaseButton :to="{ name: 'contact' }" class="basebutton isStyleLight isSmall isRadius isMobile" :class="{ isPrimary: isFixed }">
              專人聯繫 <i class="icomoon icon-arrow-button"></i>
            </BaseButton>
          </div>
        </div>
      </div>
    </div>
    <!-- </div> -->
    <!-- </div> -->
  </header>
</template>

<script>
import throttle from 'lodash/throttle'
export default {
  name:'TheHeader3',
  data() {
    return {
      isFixed: false,
      isMenuOpen: false,
      menuList: [
        {
          title: '方案價格',
          alias: 'planprice',
        },
        // {
        //   title: '預約系統方案',
        //   alias: 'reserveplan',
        // },
        // {
        //   title: '系統行銷整合方案',
        //   alias: 'marketingplan',
        // },
        // {
        //   title: '專人聯繫',
        //   alias: 'contact',
        // }
      ],
    }
  },
  mounted() {
    this.checkMenuFixed()
    window.addEventListener(
      'scroll',
      throttle(() => {
        this.checkMenuFixed()
      }, 100)
    )
  },
  destroyed() {
    window.removeEventListener(
      'scroll',
      throttle(() => {
        this.checkMenuFixed()
      }, 100)
    )
  },
  methods: {
    checkMenuFixed() {
      const scrollTop = this.getScrollTop()
      this.isFixed = scrollTop > 150
    },
    getScrollTop() {
      let scrollTop = 0
      if (typeof window.pageYOffset !== 'undefined') {
        scrollTop = window.pageYOffset
      } else if (typeof document.compatMode !== 'undefined' && document.compatMode !== 'BackCompat') {
        scrollTop = document.documentElement.scrollTop
      } else if (typeof document.body !== 'undefined') {
        scrollTop = document.body.scrollTop
      }
      return scrollTop
    },
  },
}
</script>

<style lang="scss" module>
.header {
  height: 122px;
  display: flex;
  align-items: center;
  position: relative;
  z-index: 999;
  @include max-lg {
    position: fixed;
    width: 100vw;
    max-width: 100%;
    right: 0;
    left: 0;
    height: 70px;
    box-shadow: 0px 4px 15px rgba(84, 86, 98, 0.12);
    background: $color-white;
  }
  &.isFixed {
    position: fixed;
    // top: 0;
    right: 0;
    left: 0;
    width: 100vw;
    max-width: 100%;
    height: 90px;
    box-shadow: 0px 4px 15px rgba(84, 86, 98, 0.12);
    animation-name: slideIn;
    animation-duration: 0.5s;
    background: $color-white;
    @include max-lg {
      animation: none;
      height: 70px;
    }
    :global {
      .header {
        &__link {
          color: $color-text-1;
          &.router-link-active {
            color: $color-primary;
          }
        }
        &__Inner {
        }
      }
    }
  }
  :global {
    .header {
      &__logo {
        width: 220px;
        height: 46px;
        // position: relative;
        // top: -4px;
        @include max-lg {
          max-width: 180px;
          height: 33.19px;
        }
      }
      &__headerList {
        padding-left: 40px;
        padding-right: 40px;
        width: 100vw;
        max-width: 100%;
        position: relative;
        @include max-lg {
          padding-left: 20px;
          padding-right: 20px;
        }
      }
      &__menuList {
        display: flex;
        align-items: center;
        @include max-lg {
          flex-direction: column;
          width: 100vw;
          max-width: 100%;
          position: absolute;
          top: 56px;
          left: 0;
          right: 0;
          background-color: #ffffff;
          padding-left: 30px;
          padding-right: 20px;
          // padding-top: 45px;
          // padding-bottom: 60px;
          box-shadow: 0px 4px 15px rgba(84, 86, 98, 0.12);
          max-height: 0;
          overflow: hidden;
          transition: 0.8s;
          // position: relative;
          &:before {
            content: '';
            position: absolute;
            width: 90%;
            top: 0;
            left: 0;
            right: 0;
            height: 1px;
            margin: 0 auto;
            background-color: #edf0f4;
          }
        }
        &.isActive {
          max-height: 900px;
        }
      }
      &__menuItem {
        &:not(:last-child) {
          margin-right: 50px;
          @include max-lg {
            margin-right: 0;
          }
        }
        @include max-lg {
          padding-bottom: 15px;
          padding-top: 15px;
          margin-right: 0;
          width: 100%;
          text-align: center;
          &:first-child {
            margin-top: 45px;
          }
          &:last-child {
            margin-bottom: 60px;
          }
        }
      }
      &__link {
        padding: 15px 10px;
        color: $color-white;
        text-decoration: none;
        transition: 0.3s;
        font-weight: 500;
        &.router-link-active {
          position: relative;
          &:before {
            content: '';
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            height: 5px;
            width: 5px;
            background: #fff;
            border-radius: 100px;
          }
        }
        @include max-lg {
          color: $color-text-1;
        }
        &:hover {
          color: $color-primary;
        }
      }
      &__right {
        .burger {
          font-size: 30px;
          color: $color-text-3;
          cursor: pointer;
        }
      }
    }
    .basebutton {
      @include max-lg {
        &.isMobile {
          background-color: $color-primary;
          color: #ffffff;
          box-shadow: none;
          margin-top: 10px;
          width: 100%;
        }
      }
    }

    @keyframes slideIn {
      0% {
        top: -90px;
      }
      100% {
        top: 0;
      }
    }
  }
}
</style>
